import React from 'react';
import { useAuth } from '../context/AuthContext';
import './LeaveList.css';

const LeaveList = ({ leaves, onApprove, onReject, onDelete, onRefresh, onApproveManager, onRejectManager, onApproveRH, onRejectRH }) => {
  const { hasModulePermission } = useAuth();
  const canApprove = hasModulePermission('LEAVES', 'approve');
  const canDelete = hasModulePermission('LEAVES', 'delete');
  const canView = hasModulePermission('LEAVES', 'view');

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR');
  };

  const getStatusBadge = (status) => {
    const badges = {
      PENDING: { class: 'badge-pending', label: 'En attente' },
      APPROVED: { class: 'badge-approved', label: 'Approuvé' },
      REJECTED: { class: 'badge-rejected', label: 'Rejeté' },
      CANCELLED: { class: 'badge-cancelled', label: 'Annulé' },
    };
    const badge = badges[status] || badges.PENDING;
    return <span className={`badge ${badge.class}`}>{badge.label}</span>;
  };

  const getLeaveTypeLabel = (type) => {
    const types = {
      ANNUAL: 'Congé annuel',
      SICK: 'Congé maladie',
      MATERNITY: 'Congé maternité',
      PATERNITY: 'Congé paternité',
      UNPAID: 'Congé sans solde',
      PERSONAL: 'Congé spéciaux',
      OTHER: 'Autre',
    };
    return types[type] || type;
  };

  if (leaves.length === 0) {
    return (
      <div className="empty-state">
        <p>Aucun congé trouvé.</p>
      </div>
    );
  }

  return (
    <div className="leave-list">
      <div className="table-container">
        <table className="leave-table">
          <thead>
            <tr>
              <th>Employé</th>
              <th>Type</th>
              <th>Date début</th>
              <th>Date fin</th>
              <th>Jours</th>
              <th>Statut</th>
                <th>Raison</th>
                <th>Manager</th>
                <th>RH</th>
                {(canApprove || canDelete) && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {leaves.map((leave) => (
              <tr key={leave.id}>
                <td>{leave.employeeName}</td>
                <td>{getLeaveTypeLabel(leave.leaveType)}</td>
                <td>{formatDate(leave.startDate)}</td>
                <td>{formatDate(leave.endDate)}</td>
                <td>{leave.numberOfDays}</td>
                <td>{getStatusBadge(leave.status)}</td>
                <td className="reason-cell">{leave.reason || '-'}</td>
                <td>
                  {leave.approvedByManager ? (
                    <span className="approver-name">✓ {leave.approvedByManager}</span>
                  ) : leave.status === 'PENDING' && canApprove ? (
                    <div className="action-buttons">
                      <button
                        onClick={() => onApproveManager(leave.id)}
                        className="btn-action btn-approve"
                        title="Approuver"
                      >
                        ✓
                      </button>
                      <button
                        onClick={() => onRejectManager(leave.id)}
                        className="btn-action btn-reject"
                        title="Rejeter"
                      >
                        ✗
                      </button>
                    </div>
                  ) : (
                    <span className="pending-text">-</span>
                  )}
                </td>
                <td>
                  {leave.approvedByRh ? (
                    <span className="approver-name">✓ {leave.approvedByRh}</span>
                  ) : (leave.status === 'MANAGER_APPROVED' || leave.status === 'PENDING') && canApprove ? (
                    <div className="action-buttons">
                      <button
                        onClick={() => onApproveRH(leave.id)}
                        className="btn-action btn-approve"
                        title="Approuver"
                      >
                        ✓
                      </button>
                      <button
                        onClick={() => onRejectRH(leave.id)}
                        className="btn-action btn-reject"
                        title="Rejeter"
                      >
                        ✗
                      </button>
                    </div>
                  ) : (
                    <span className="pending-text">-</span>
                  )}
                </td>
                {(canApprove || canDelete) && (
                  <td>
                    <div className="action-buttons">
                      {canDelete && (
                        <button
                          onClick={() => onDelete(leave.id)}
                          className="btn-action btn-delete"
                          title="Supprimer"
                        >
                          🗑️
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaveList;

